<template>
  <div>
    <b-card-actions action-collapse title="Guide line Port">
      <div>
        <div class="custom-search d-flex justify-content-end">
          <div class="text-right mlr10" @click="saveGuideLinePorts()">
            <b-button variant="gradient-primary" class="btn-icon">
              <feather-icon icon="SaveIcon" />
            </b-button>
          </div>
          <b-button
            variant="gradient-primary"
            class="btn-icon mr-1"
            @click="downloadXLSX"
          >
            Download
            <feather-icon icon="DownloadIcon" />
          </b-button>
          <vue-xlsx-table
            @on-select-file="handleSelectedFile"
            class="btn-icon-upload"
          >
            Upload
            <feather-icon icon="UploadIcon" />
          </vue-xlsx-table>
        </div>
        <div class="container-elements">
          <b-row
            :class="getRowStyle(i)"
            v-for="(item, i) in portsTab"
            :id="i"
            :key="i"
          >
            <!-- :style="getRowStyle(i)" -->
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="Start date">
                <b-form-datepicker
                  placeholder="Voyage"
                  v-model="item.startDate"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label="End date">
                <b-form-datepicker
                  placeholder="Voyage"
                  v-model="item.endDate"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="addGuideline"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>

            <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2"
                @click="removeGuideline(i)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
            <b-row
              class="row-ports"
              v-for="(port, j) in item.ports"
              :id="j"
              :key="j"
            >
              <b-col b-col cols="12" lg="3" md="3" sm="12">
                <b-form-group label="Depart" label-for="Depart">
                  <v-select
                    id="Depart"
                    v-model="port.departurePort.title"
                    placeholder="Depart"
                    :options="port.departureArray"
                    @input="updateArrivalPorts(port.departurePort.title, i, j)"
                  >
                  </v-select>
                </b-form-group>
              </b-col>

              <b-col b-col cols="12" lg="3" md="3" sm="12">
                <b-form-group label="Arrival" label-for="Arrival">
                  <v-select
                    id="Arrival"
                    v-model="port.arrivalPort.title"
                    placeholder="Arrival"
                    :options="port.arrivalArray"
                    @input="updateDeparturePorts(port.arrivalPort.title, i, j)"
                  >
                  </v-select>
                </b-form-group>
              </b-col>

              <b-col b-col cols="12" lg="2" md="2" sm="12">
                <b-form-group label-for="price" label="Price">
                  <b-form-input
                    id="price"
                    placeholder="Price"
                    v-model="port.price"
                    required
                    class="input-outline-bleu-border"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="2" md="2" sm="12">
                <b-form-group label-for="currency" label="Currency">
                  <v-select
                    id="currency"
                    placeholder="Currency"
                    :options="currencyOptions"
                    v-model="port.currency"
                    required
                    class="input-outline-bleu-border"
                  ></v-select>
                </b-form-group>
              </b-col>
              <b-col lg="1" md="1" cols="12" class="mb-50">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-success"
                  class="mt-0 mt-md-2"
                  @click="addPort(i)"
                >
                  <feather-icon icon="PlusIcon" />
                </b-button>
              </b-col>

              <b-col v-if="j > 0" lg="1" md="1">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-0 mt-md-2"
                  @click="removePort(i, j)"
                >
                  <feather-icon icon="XIcon" />
                </b-button>
              </b-col>
            </b-row>
            <hr />
          </b-row>
        </div>
      </div>
    </b-card-actions>

    <b-card-actions action-collapse title="Guide line Classe">
      <div>
        <div class="custom-search d-flex justify-content-end">
          <div class="text-right mlr10" @click="saveGuideLineClasses()">
            <b-button variant="gradient-primary" class="btn-icon">
              <feather-icon icon="SaveIcon" />
            </b-button>
          </div>
          <b-button
            variant="gradient-primary"
            class="btn-icon mr-1"
            @click="downloadClasseXLSX"
          >
            Download
            <feather-icon icon="DownloadIcon" />
          </b-button>
          <vue-xlsx-table
            @on-select-file="uploadClasseXLSX"
            class="btn-icon-upload"
          >
            Upload
            <feather-icon icon="UploadIcon" />
          </vue-xlsx-table>
        </div>
        <div>
          <b-row
            :class="getRowStyle(i)"
            v-for="(item, i) in classesTab"
            :id="item.id"
            :key="i"
          >
            <b-col b-col cols="12" lg="10" md="10" sm="12">
              <b-form-group label-for="classe" label="Classe">
                <b-form-input
                  id="classe"
                  placeholder="Classe"
                  v-model="item.title"
                  required
                  class="input-outline-bleu-border"
                ></b-form-input>
                <!-- <v-select
                  id="classe"
                  placeholder="Classe"
                  :options="classOptions"
                  v-model="item.title"
                  required
                  class="input-outline-bleu-border"
                ></v-select> -->
              </b-form-group>
            </b-col>
            <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="addClasse(i)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>

            <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 ml-1"
                @click="removeClasse(i)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>

            <b-row
              class="row-ports"
              v-for="(element, j) in item.priceTab"
              :id="j"
              :key="j"
            >
              <b-col b-col cols="12" lg="3" md="3" sm="12">
                <b-form-group label-for="price" label="Price (TND)">
                  <b-form-input
                    id="price"
                    placeholder="Price"
                    v-model="element.price"
                    required
                    class="input-outline-bleu-border"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="3" md="3" sm="12">
                <b-form-group label-for="currency" label="Currency">
                  <v-select
                    id="currency"
                    placeholder="Currency"
                    :options="currencyOptions"
                    v-model="element.currency"
                    required
                    class="input-outline-bleu-border"
                  ></v-select>
                </b-form-group>
              </b-col>
              <b-col lg="1" md="1" cols="12" class="mb-50">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-success"
                  class="mt-0 mt-md-2"
                  @click="addPriceSubElement(item.priceTab, j)"
                >
                  <feather-icon icon="PlusIcon" />
                </b-button>
              </b-col>

              <b-col v-if="j > 0" lg="1" md="1">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-0 mt-md-2 ml-1"
                  @click="removePriceSubElement(item.priceTab, j)"
                >
                  <feather-icon icon="XIcon" />
                </b-button>
              </b-col>
            </b-row>
            <hr />
          </b-row>
        </div>
      </div>
    </b-card-actions>

    <!--<b-card-actions action-collapse title="Guide line UN">
      <div >
        <div class="custom-search d-flex justify-content-end">
          <div class="text-right mlr10" @click="saveGuideLineUns()">
            <b-button variant="gradient-primary" class="btn-icon">
              <feather-icon icon="SaveIcon" />
            </b-button>
          </div>
          <div class="btn-delete-all text-right" @click="uploadData()">
            <b-button variant="gradient-primary" class="btn-icon btn-delete-all">
            <feather-icon icon="UploadIcon" />
            </b-button>
          </div> -->
    <!--<vue-xlsx-table @on-select-file="handleSelectedFile" class="btn-icon-upload"><feather-icon icon="UploadIcon" /></vue-xlsx-table>

        </div>
        <div>
          <b-row
            class="mt-1"
            v-for="(item, i) in unsTab"
            :id="item.id"
            :key="i"
          >

          <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label-for="un" label="UN">
                <b-form-input
                  id="un"
                  placeholder="UN"
                  v-model="item.title"
                  required
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col b-col cols="12" lg="5" md="5" sm="12">
              <b-form-group label-for="price" label="Price">
                <b-form-input
                  id="price"
                  placeholder="Price"
                  v-model="item.price"
                  required
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="addUn(i)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col>

            <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 ml-1"
                @click="removeUn(i)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col>
            <hr />
          </b-row>
        </div>
      </div>
    </b-card-actions>-->

    <b-card-actions action-collapse title="Guide line Container">
      <div>
        <div class="custom-search d-flex justify-content-end">
          <div class="text-right mlr10" @click="saveGuideLineContainers()">
            <b-button variant="gradient-primary" class="btn-icon">
              <feather-icon icon="SaveIcon" />
            </b-button>
          </div>
          <b-button
            variant="gradient-primary"
            class="btn-icon mr-1"
            @click="downloadContainerXLSX"
          >
            Download
            <feather-icon icon="DownloadIcon" />
          </b-button>
          <vue-xlsx-table
            @on-select-file="uploadContainerXLSX"
            class="btn-icon-upload"
          >
            Upload
            <feather-icon icon="UploadIcon"
          /></vue-xlsx-table>
        </div>
        <div>
          <b-row
            :class="getRowStyle(i)"
            v-for="(item, i) in containersTab"
            :id="item.id"
            :key="i"
          >
            <!-- <b-col b-col cols="12" lg="4" md="4" sm="12">
              <b-form-group label-for="container" label="Container">
                <b-form-input
                  id="container"
                  placeholder="Container"
                  v-model="item.title"
                  required
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col> -->
            <b-col b-col cols="12" lg="6" md="6" sm="12">
              <b-form-group label-for="container" label="Size/type">
                <b-form-input
                  id="container"
                  placeholder="Size/type"
                  v-model="item.sizeType"
                  disabled
                  class="input-outline-bleu-border"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col b-col cols="12" lg="6" md="6" sm="12">
              <b-form-group label-for="weight" label="Weight">
                <b-form-input
                  id="weight"
                  placeholder="Weight"
                  v-model="item.weight"
                  required
                  class="input-outline-bleu-border"
                  @change="financial(item)"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <!-- <b-col lg="1" md="1" cols="12" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="mt-0 mt-md-2"
                @click="addContainer(i)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </b-col> -->

            <!-- <b-col v-if="i > 0" lg="1" md="1">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2 ml-1"
                @click="removeContainer(i)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </b-col> -->

            <b-row
              class="row-ports"
              v-for="(element, j) in item.priceTab"
              :id="j"
              :key="j"
            >
              <b-col cols="12" lg="3" md="3" sm="12">
                <b-form-group label-for="currency" label="Currency">
                  <v-select
                    id="currency"
                    placeholder="Currency"
                    :options="currencyOptions"
                    v-model="element.currency"
                    required
                    class="input-outline-bleu-border"
                  ></v-select>
                </b-form-group>
              </b-col>
              <b-col b-col cols="12" lg="3" md="3" sm="12">
                <b-form-group label-for="price" label="Price">
                  <b-form-input
                    id="price"
                    placeholder="Price"
                    v-model="element.price"
                    required
                    class="input-outline-bleu-border"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col b-col cols="12" lg="3" md="3" sm="12">
                <b-form-group label-for="max-price" label="Max Price">
                  <b-form-input
                    id="max-price"
                    placeholder="Max Price"
                    v-model="element.priceMax"
                    required
                    class="input-outline-bleu-border"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="1" md="1" cols="12" class="mb-50">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-success"
                  class="mt-0 mt-md-2"
                  @click="addPriceSubElement(item.priceTab, j)"
                >
                  <feather-icon icon="PlusIcon" />
                </b-button>
              </b-col>

              <b-col v-if="j > 0" lg="1" md="1">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-0 mt-md-2 ml-1"
                  @click="removePriceSubElement(item.priceTab, j)"
                >
                  <feather-icon icon="XIcon" />
                </b-button>
              </b-col>
            </b-row>

            <hr />
          </b-row>
        </div>
      </div>
    </b-card-actions>
  </div>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  BFormDatepicker,
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import * as XLSX from "xlsx";
import currencyList from "../../../Common-Currency.json";
import { forEach } from 'postcss-rtl/lib/affected-props';

export default {
  components: {
    BFormDatepicker,
    ToastificationContent,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BCardActions,
    BFormSelect,
    vSelect,
    XLSX,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      currencyOptions: [],
      portsTab: [
        {
          id: 0,
          startDate: null,
          endDate: null,
          ports: [
            {
              id: 0,
              departurePort: {
                _id: null,
                title: null,
              },
              arrivalPort: {
                _id: null,
                title: null,
              },
              price: null,
              currency: "TND",
              arrivalArray: [],
              departureArray: [],
            },
          ],
        },
      ],
      classesTab: [
        {
          id: 1,
          title: "",
          priceTab: [
            {
              id: 1,
              price: null,
              currency: "TND",
            },
          ],
        },
      ],
      // unsTab: [
      //   {
      //     _id: null,
      //     id: 1,
      //     title: "",
      //     price: null,
      //   },
      // ],
      containersTab: [
        {
          _id: null,
          id: 1,
          title: "",
          weight: null,
          priceTab: [
            {
              id: 1,
              price: null,
              currency: "TND",
              priceMax: null,
            },
          ],
        },
      ],
      containersTabTemp:[],
      // classOptions:[],
      ports: [],
      arrivalArray: [],
      departureArray: [],
      hasDuplicatePair: false,
      requires: false,
      filename: "Guidline.xlsx",
    };
  },
  async created() {
    this.currencyOptions = Object.keys(currencyList);
    window.addEventListener("resize", this.initTrHeight);
    await this.getPorts();
    await this.getGuidelinePorts();
    await this.getGuidelineClasses();
    // this.getGuidelineUns();
    await this.getGuidelineContainers();
    // await this.getDataClass();
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    // async getDataClass(){
    //   await axios
    //   .get(
    //     "https://mtl-feeder-nodejs.onrender.com/api/classes"
    //   )
    //     .then((response) => {
    //       const titlesArray1 = this.classesTab.map(item => item.title);
    //       this.classOptions = response.data.data.filter(item => !titlesArray1.includes(item.title));
    // console.log("this.classOptions",this.classOptions,titlesArray1,response.data.data)
    //       // response.data.data.forEach((element,index) => {

    //       //   this.classesTab.forEach(item => {
    //       //     if(item.title != element.title){
    //       //       this.classOptions.push(element.title)
    //       //     }
    //       //   });

    //       // });
    //   })
    //     .catch((error) => {
    //       this.errorMessage = error.message;
    //   });

    // },
    getRowStyle(index) {
      // return {
      //   backgroundColor: index % 2 === 0 ? "#ededed" : "white",
      // };
      if (index % 2 === 0) {
        return "mt-1 pt-1 pb-1 background-element-gray";
      } else {
        return "mt-1 pt-1 pb-1";
      }
      // return {
      //    backgroundColor: index % 2 === 0 ? "mt-1 pt-1 pb-1 background-element-gray" : "mt-1 pt-1 pb-1",
      //  };
    },
    async getPorts() {
      const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/ports");
      response.data.data.forEach((element, index) => {
        this.ports.push({
          label: element.title,
          value: element._id,
        });
      });
    },
    async getGuidelinePorts() {
      const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/guidelines");
      if (response.data.data.length === 0) {
        console.log("this.ports", response);
        this.portsTab[0].ports[0].arrivalArray = this.ports;
        this.portsTab[0].ports[0].departureArray = this.ports;
        if (this.portsTab[0]._id) {
          delete this.portsTab[0]._id;
        }
      } else {
        console.log("this.ports", response);
        this.portsTab = [];
        response.data.data.forEach((element, index) => {
          if (element._id) {
            var newElement = {
              _id: element._id,
              id: index,
              startDate: element.startDate,
              endDate: element.endDate,
              ports: [],
            };
          }
          element.ports.forEach((port) => {
            if (port.departurePort == null) {
              port.departurePort = {
                _id: null,
                title: null,
              };
            }
            if (port.arrivalPort == null) {
              port.arrivalPort = {
                _id: null,
                title: null,
              };
            }
            let modifiedPort = {
              ...port,
              departurePort: {
                _id: port.departurePort._id,
                title: port.departurePort.title,
              },
              arrivalPort: {
                _id: port.arrivalPort._id,
                title: port.arrivalPort.title,
              },
              arrivalArray: this.ports.filter(
                (item) => item.value !== port.departurePort._id
              ),
              departureArray: this.ports.filter(
                (item) => item.value !== port.arrivalPort._id
              ),
            };
            newElement.ports.push(modifiedPort);
          });
          this.portsTab.push(newElement);
        });
      }
    },
    async getGuidelineClasses() {
      this.classesTab = [];
      const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/classes");
      if (response.data.data.length === 0) {
        this.classesTab.push({
          id: 1,
          title: "",
          priceTab: [
            {
              id: 1,
              price: null,
              currency: "TND",
            },
          ],
        });
      } else {
        response.data.data.forEach((element, index) => {
          if (element.priceTab.length == 0) {
            this.classesTab.push({
              _id: element._id,
              id: index,
              title: element.title,
              priceTab: [
                {
                  id: 1,
                  price: null,
                  currency: "TND",
                },
              ],
            });
          } else {
            this.classesTab.push({
              _id: element._id,
              id: index,
              title: element.title,
              priceTab: element.priceTab,
            });
          }
        });
      }
    },
    // async getGuidelineUns() {
    //   this.unsTab = [];
    //   const response = await axios.get(
    //     "https://mtl-feeder-nodejs.onrender.com/api/uns"
    //   );
    //   response.data.data.forEach((element, index) => {
    //     this.unsTab.push({
    //       _id: element._id,
    //       id: index,
    //       title: element.title,
    //       price: element.price,
    //     });
    //   });
    // },
    async getGuidelineContainers() {
      this.containersTab = [];
      const response = await axios.get("https://mtl-feeder-nodejs.onrender.com/api/containers");
      console.log("container", response.data.data);
      if (response.data.data.length === 0) {
        this.containersTab.push({
          id: 1,
          // title: "",
          sizeType: "",
          weight: null,
          priceTab: [
            {
              id: 1,
              price: null,
              currency: "TND",
              priceMax: null,
            },
          ],
        });
        this.containersTabTemp.push({
          id: 1,
          // title: "",
          sizeType: "",
          weight: null,
          priceTab: [
            {
              id: 1,
              price: null,
              currency: "TND",
              priceMax: null,
            },
          ],
        });
      } else {
        const sizeTypeSet = new Set();
        response.data.data.forEach((element, index) => {
          if (!sizeTypeSet.has(element.sizeType)) {
            sizeTypeSet.add(element.sizeType);
            if (element.priceTab.length == 0) {
              this.containersTab.push({
                _id: element._id,
                id: index,
                // title: element.title,
                sizeType: element.sizeType,
                weight: element.weight,
                priceTab: [
                  {
                    id: 1,
                    price: null,
                    currency: "TND",
                    priceMax: null,
                  },
                ],
              });
            } else {
              this.containersTab.push({
                _id: element._id,
                id: index,
                // title: element.title,
                sizeType: element.sizeType,
                weight: element.weight,
                priceTab: element.priceTab,
              });
            }
          }

            if (element.priceTab.length == 0) {
              this.containersTabTemp.push({
                _id: element._id,
                id: index,
                // title: element.title,
                sizeType: element.sizeType,
                weight: element.weight,
                priceTab: [
                  {
                    id: 1,
                    price: null,
                    currency: "TND",
                    priceMax: null,
                  },
                ],
              });
            } else {
              this.containersTabTemp.push({
                _id: element._id,
                id: index,
                // title: element.title,
                sizeType: element.sizeType,
                weight: element.weight,
                priceTab: element.priceTab,
              });
            }

        });
      }
    },
    updateArrivalPorts(port, index1, index2) {
      this.portsTab[index1].ports[index2].departurePort._id = port
        ? port.value
        : null;
      this.portsTab[index1].ports[index2].departurePort.title = port
        ? port.label
        : null;
      this.portsTab[index1].ports[index2].arrivalArray = port
        ? this.ports.filter((item) => item.value !== port.value)
        : this.ports;
    },
    updateDeparturePorts(port, index1, index2) {
      this.portsTab[index1].ports[index2].arrivalPort._id = port
        ? port.value
        : null;
      this.portsTab[index1].ports[index2].arrivalPort.title = port
        ? port.label
        : null;
      this.portsTab[index1].ports[index2].departureArray = port
        ? this.ports.filter((item) => item.value !== port.value)
        : this.ports;
    },
    async saveGuideLinePorts() {
      this.requires = false;
      const filteredPorts = this.portsTab.filter(
        (element) => element.startDate !== null || element.endDate !== null
      );
      const hasNullValue = filteredPorts.some((element) => {
        return (
          Object.values(element).some(
            (value) => value === null || value === ""
          ) ||
          element.ports.some((port) =>
            Object.values(port).some((value) => value === null || value === "")
          ) ||
          element.ports.some(
            (port) =>
              port.departurePort.title === null ||
              port.arrivalPort.title === null
          )
        );
      });
      if (hasNullValue) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please fill the form",
            icon: "EditIcon",
            variant: "warning",
          },
        });
      } else {
        this.hasDuplicatePair = false;
        filteredPorts.forEach((element) => {
          for (let i = 0; i < element.ports.length - 1; i++) {
            const currentPair = `${element.ports[i].departurePort._id}-${element.ports[i].arrivalPort._id}`;
            for (let j = i + 1; j < element.ports.length; j++) {
              const nextPair = `${element.ports[j].departurePort._id}-${element.ports[j].arrivalPort._id}`;
              if (
                currentPair !== "null-null" &&
                nextPair !== "null-null" &&
                currentPair === nextPair
              ) {
                this.hasDuplicatePair = true;
              }
            }
          }
        });
        if (this.hasDuplicatePair) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Guide line Port Duplicated",
              icon: "EditIcon",
              variant: "warning",
            },
          });
        } else {
          let formCopy = JSON.parse(JSON.stringify(filteredPorts));
          formCopy.forEach((element) => {
            element.ports.forEach((port) => {
              port.departurePort = port.departurePort._id
                ? port.departurePort._id
                : null;
              port.arrivalPort = port.arrivalPort._id
                ? port.arrivalPort._id
                : null;
              delete port.departureArray;
              delete port.arrivalArray;
              delete port.id;
            });
            delete element.id;
          });
          console.log("formCopy", formCopy);
          axios
            .post("https://mtl-feeder-nodejs.onrender.com/api/guidelines", formCopy)
            .then((response) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Guide line port updated",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error during update",
                  icon: "EditIcon",
                  variant: "danger",
                },
              });
            });
        }
      }
    },
    saveGuideLineClasses() {
      const filteredData = this.classesTab.filter(
        (obj) =>
          obj.title !== "" ||
          (obj.price !== "" && obj.price !== null) ||
          obj.currency !== ""
      );
      axios
        .post("https://mtl-feeder-nodejs.onrender.com/api/classes", filteredData)
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Guide line classe updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },
    // saveGuideLineUns() {
    //   const filteredData = this.unsTab.filter(
    //     (obj) => obj.title !== "" || (obj.price !== "" && obj.price !== null)
    //   );
    //   axios
    //     .post("https://mtl-feeder-nodejs.onrender.com/api/uns", filteredData)
    //     .then((response) => {
    //       this.$toast({
    //         component: ToastificationContent,
    //         props: {
    //           title: "Guide line UN updated",
    //           icon: "EditIcon",
    //           variant: "success",
    //         },
    //       });
    //     })
    //     .catch((error) => {
    //       this.$toast({
    //         component: ToastificationContent,
    //         props: {
    //           title: "Error during update",
    //           icon: "EditIcon",
    //           variant: "danger",
    //         },
    //       });
    //     });
    // },
    saveGuideLineContainers() {

      this.containersTab.forEach((element) => {
        this.containersTabTemp.forEach((item) => {
          if (element.sizeType == item.sizeType && element.priceTab != null) {
            item.priceTab=element.priceTab
            item.weight=element.weight
          }
        })
         
      });

      const filteredData = this.containersTabTemp.filter((item) => {
        const propertyKeys = Object.keys(item).filter((key) => key !== "id");
        return propertyKeys.some(
          (key) => item[key] !== null && item[key] !== ""
        );
      });

      
      axios
        .post("https://mtl-feeder-nodejs.onrender.com/api/containers", filteredData)
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Guide line Containers updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });
    },
    addGuideline() {
      this.portsTab.push({
        id: this.portsTab.length,
        startDate: null,
        endDate: null,
        ports: [
          {
            id: 0,
            departurePort: {
              _id: null,
              title: null,
            },
            arrivalPort: {
              _id: null,
              title: null,
            },
            price: null,
            arrivalArray: this.ports,
            departureArray: this.ports,
          },
        ],
      });
    },
    removeGuideline(index) {
      this.portsTab.splice(index, 1);
    },
    addPort(index) {
      this.portsTab[index].ports.push({
        id: this.portsTab[index].ports.length,
        departurePort: {
          _id: null,
          title: null,
        },
        arrivalPort: {
          _id: null,
          title: null,
        },
        price: null,
        currency: "TND",
        arrivalArray: this.ports,
        departureArray: this.ports,
      });
    },
    removePort(index1, index2) {
      this.portsTab[index1].ports.splice(index2, 1);
    },
    addClasse() {
      this.classesTab.push({
        id: this.classesTab.length,
        title: "",
        priceTab: [
          {
            id: 1,
            price: null,
            currency: "TND",
          },
        ],
      });
    },
    removeClasse(index) {
      this.classesTab.splice(index, 1);
    },
    addPriceSubElement(element, j) {
      console.log("element", element);
      element.push({
        id: j + 1,
        price: null,
        currency: "TND",
      });
    },
    removePriceSubElement(element, index) {
      element.splice(index, 1);
    },
    // addUn() {
    //   this.unsTab.push({
    //     id: this.unsTab.length,
    //     title: "",
    //     price: null,
    //   });
    // },
    // removeUn(index) {
    //   this.unsTab.splice(index, 1);
    // },
    addContainer() {
      this.containersTab.push({
        id: this.containersTab.length,
        title: "",
        price: null,
        priceMax: null,
        weight: null,
        currency: "TND",
      });
    },
    removeContainer(index) {
      this.containersTab.splice(index, 1);
    },
    financial(item) {
      if (item.weight === null || item.weight.trim() === "") {
        item.weight = null;
      } else {
        item.weight = Number.parseFloat(item.weight).toFixed(3);
      }
    },
    handleSelectedFile(convertedData) {
      let lastId = this.portsTab[this.portsTab.length - 1].id;
      let currentGroup = {
        startDate: null,
        endDate: null,
        ports: [],
      };
      const transformedData = [];

      convertedData.body.forEach((element) => {
        if (element["Start Date"] && element["End Date"]) {
          lastId++;
          if (currentGroup.startDate && currentGroup.endDate) {
            transformedData.push(currentGroup);
          }
          currentGroup = {
            id: lastId,
            startDate: new Date(element["Start Date"]),
            endDate: new Date(element["End Date"]),
            ports: [],
          };
        }

        if (element["Arrival Port"] && element["Departure Port"]) {
          const port1 = this.ports.find(
            (p) => p.label === element["Arrival Port"]
          );
          const port2 = this.ports.find(
            (p) => p.label === element["Departure Port"]
          );
          currentGroup.ports.push({
            arrivalArray: this.ports.filter(
              (item) => item.label !== element["Departure Port"]
            ),
            departureArray: this.ports.filter(
              (item) => item.label !== element["Arrival Port"]
            ),
            arrivalPort: {
              title: element["Arrival Port"],
              _id: port1 ? port1.value : null,
            },
            departurePort: {
              title: element["Departure Port"],
              _id: port2 ? port2.value : null,
            },
            price: element["Price"],
            currency: element["currency"],
          });
        }
      });

      if (currentGroup.startDate && currentGroup.endDate) {
        transformedData.push(currentGroup);
      }
      this.portsTab = this.portsTab.concat(transformedData);
    },
    uploadClasseXLSX(convertedData) {
      const result = [];
      // let lastId = this.classesTab[this.classesTab.length - 1].id;
      const classesMap = new Map();
      convertedData.body.forEach((item) => {
        const { Classe, Price, currency } = item;
        if (!classesMap.has(Classe)) {
          const newClass = {
            id: result.length + 1,
            title: Classe,
            priceTab: [],
          };
          result.push(newClass);
          classesMap.set(Classe, newClass);
        }
        const classItem = classesMap.get(Classe);
        classItem.priceTab.push({
          id: classItem.priceTab.length + 1,
          price: Number(Price),
          currency,
        });
      });
      // convertedData.body.forEach((element) => {
      //   lastId++;

      //   // data.push({
      //   //   id: lastId,
      //   //   title: element["Classe"],
      //   //   price: element["Price"],
      //   //   currency: element["currency"],
      //   // });
      // });
      this.classesTab = this.classesTab.concat(result);
    },
    uploadContainerXLSX(convertedData) {
      const result = [];
      // let lastId = this.classesTab[this.classesTab.length - 1].id;
      const containerMap = new Map();
      convertedData.body.forEach((item) => {
        const { Container, Weight, Price, currency, priceMax } = item;
        if (!containerMap.has(Container)) {
          const newContainer = {
            id: result.length + 1,
            title: Container,
            sizeType: sizeType,
            weight: Weight,
            priceTab: [],
          };
          result.push(newContainer);
          containerMap.set(Container, newContainer);
        }
        const classItem = containerMap.get(Container);
        classItem.priceTab.push({
          id: classItem.priceTab.length + 1,
          price: Number(Price),
          priceMax: Number(priceMax),
          currency,
        });
      });
      // const data = [];
      // let lastId = this.containersTab[this.containersTab.length - 1].id;
      // convertedData.body.forEach((element) => {
      //   lastId++;
      //   data.push({
      //     id: lastId,
      //     title: element["Container"],
      //     price: element["Price"],
      //     priceMax: element["Max Price"],
      //     weight: element["Weight"],
      //     currency: element["currency"],
      //   });
      // });
      this.containersTab = this.containersTab.concat(result);
    },
    flattenedData() {
      const data = [];
      this.portsTab.forEach((tab) => {
        tab.ports.forEach((port, index) => {
          if (index === 0) {
            data.push({
              "Start Date": moment(tab.startDate).format("MM/DD/YYYY"),
              "End Date": moment(tab.endDate).format("MM/DD/YYYY"),
              "Departure Port": port.departurePort.title || "",
              "Arrival Port": port.arrivalPort.title || "",
              Price: port.price || "",
              currency: port.currency || "",
            });
          } else {
            data.push({
              "Start Date": "",
              "End Date": "",
              "Departure Port": port.departurePort.title || "",
              "Arrival Port": port.arrivalPort.title || "",
              Price: port.price || "",
              currency: port.currency || "",
            });
          }
        });
        data.push({});
      });
      return data;
    },
    downloadXLSX() {
      const worksheet = XLSX.utils.json_to_sheet(this.flattenedData());
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Ports");
      XLSX.writeFile(workbook, "GuidelinePort.xlsx");
    },
    downloadClasseXLSX() {
      const data = [];
      // this.classesTab.forEach((classe) => {
      //   data.push({
      //     Classe: classe.title,
      //     Price: classe.price,
      //     currency: classe.currency,
      //   });
      // });

      this.classesTab.forEach((classe) => {
        classe.priceTab.forEach((price) => {
          data.push({
            Classe: classe.title,
            Price: price.price,
            currency: price.currency,
          });
        });
      });

      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Classes");
      XLSX.writeFile(workbook, "GuidelineClasse.xlsx");
    },
    downloadContainerXLSX() {
      const data = [];
      this.containersTabTemp.forEach((container) => {
        container.priceTab.forEach((price) => {
          data.push({
            Container: container.title,
            SizeType: container.sizeType,
            Weight: container.weight,
            Price: price.price,
            priceMax: price.priceMax,
            currency: price.currency,
          });
        });
      });
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Containers");
      XLSX.writeFile(workbook, "GuidelineContainer.xlsx");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
[dir="ltr"] .vs--single .vs__dropdown-toggle {
  background-color: white !important;
}

.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
  background-color: #ededed;
}
.btn-add {
  margin-top: 20px;
}
.btn-icon-upload button {
  background-image: linear-gradient(47deg, #010022, #030055) !important;
  padding: 0.715rem 0.736rem;
  text-align: center;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.358rem;
}
.row-ports {
  width: 100% !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.background-element-gray {
  background-color: #ededed !important;
}
.dark-layout .background-element-gray {
  background-color: #161d31 !important;
}
</style>